export const ALLOW_PHONE_AS_ID = 'allowPhoneAsId';
export const ENABLE_SERVICE_LOCATION_ROLLUP = 'enableServiceLocationRollup';
